import { URL } from './URL'

const getAuthHeader = () => {
  const token = JSON.parse(localStorage.getItem('accessToken'))
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  }
}

export async function getAllMenus() {
  try {
    const response = await fetch(`${URL}/menu/all`, {
      method: 'GET',
      headers: getAuthHeader(),
    })
    if (
      response.status === 200 ||
      response.status === 201 ||
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    }
    const errorResponse = await response.json()
    throw new Error(errorResponse.error)
  } catch (error) {
    console.error(error)
  }
}

export async function getRoleMenuByKpost(kpostId) {
  try {
    const response = await fetch(`${URL}/roleMenu/${kpostId}`, {
      method: 'GET',
      headers: getAuthHeader(),
    })
    if (
      response.status === 200 ||
      response.status === 201 ||
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    }
    const errorResponse = await response.json()
    throw new Error(errorResponse.error)
  } catch (error) {
    console.error(error)
  }
}

export async function assignRoleMenu(body) {
  try {
    const response = await fetch(`${URL}/roleMenu/assign`, {
      method: 'POST',
      headers: getAuthHeader(),
      body: JSON.stringify(body),
    })
    if (
      response.status === 200 ||
      response.status === 201 ||
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    }
    const errorResponse = await response.json()
    throw new Error(errorResponse.error)
  } catch (error) {
    console.error(error)
  }
}

/**
 * Convert menu/all API response into the shape TreePermission expects:
 *   { id, label, children, permissions }
 * Any node without a non-empty subMenu is treated as a leaf and gets
 * permissions:true so the action checkboxes render.
 */
export const transformMenuResponse = (menus = []) =>
  menus.map((m) => {
    const hasChildren = Array.isArray(m.subMenu) && m.subMenu.length > 0
    return {
      id: m.id,
      label: m.menuName,
      url: m.url,
      icon: m.icon,
      order: m.order,
      children: hasChildren ? transformMenuResponse(m.subMenu) : [],
      permissions: !hasChildren,
    }
  })

// Flatten the entire menu tree into { [menuId]: url } for quick lookup.
const flattenMenuTree = (menus = [], acc = {}) => {
  menus.forEach((m) => {
    if (m.id && m.url) acc[m.id] = m.url
    if (Array.isArray(m.subMenu) && m.subMenu.length > 0) {
      flattenMenuTree(m.subMenu, acc)
    }
  })
  return acc
}

/**
 * Cross-reference menu/all with roleMenu/{kpostId} to produce:
 *   { [menuUrl]: string[] }  e.g. { '/dashboard': ['VIEW','CREATE'] }
 *
 * @param {Array} allMenus      - raw response from GET menu/all
 * @param {Array} rolePrivileges - array of { menuId, permissions[] }
 *                                 (pass roleData.privileges or roleData directly)
 */
export const buildPrivilegeMap = (allMenus = [], rolePrivileges = []) => {
  const rawMenus = Array.isArray(allMenus)
    ? allMenus
    : allMenus?.data || allMenus?.menus || []

  const rawPrivs = Array.isArray(rolePrivileges)
    ? rolePrivileges
    : rolePrivileges?.privileges || []

  const idToUrl = flattenMenuTree(rawMenus)
  const map = {}
  rawPrivs.forEach(({ menuId, permissions }) => {
    const url = idToUrl[menuId]
    if (url) map[url] = permissions || []
  })
  return map
}
